import React, { FC, useEffect, useState } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Box, FormControl, InputLabel, Select } from '@material-ui/core';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  className?: any;
  value?: string;
  onChange: (providerId?: string) => void;
}

const ProviderSelect: FC<Props> = React.forwardRef<any, Props>(({ value, onChange, className }, ref) => {
  const [providers, setProviders] = useState<Array<{ id: string; name: string }>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const { fetch } = useAuth();

  const fetchProviders = () => {
    return fetch('/api/providers/', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then((resp) => resp.json());
  };

  const handleProviderChange = (event) => {
    const value = event.target.value;
    onChange(value);
  };

  useEffect(() => {
    fetchProviders()
      .then((providers) => {
        setProviders(providers);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <Box color='#f44336'>{error}</Box>;
  }

  return (
    <FormControl ref={ref} className={className} fullWidth>
      <InputLabel shrink>Prestataire</InputLabel>
      <Select value={value} onChange={handleProviderChange} native>
        <option value=''>Choisir un prestataire</option>
        {providers.map((provider) => (
          <option key={provider.id} value={provider.id}>
            {provider.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
});

export default React.memo(ProviderSelect);
